import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.css']
})
export class SearchFieldComponent implements OnInit {

  separatorKeysCodes: number[] = [ENTER, COMMA];

  selectedOptions: string[] = [];
  filteredOptions: Observable<string[]>;
  
  @ViewChild('stationInput') optionInput: ElementRef<HTMLInputElement>;
  inputCtrl: FormControl = new FormControl();
  
  @Input() labelText: string;
  @Input() placeholder: string;
  @Input() allOptions: string[] = [];
  @Output() selectedOptionsChanged = new EventEmitter<string[]>();

  constructor() {
    this.filteredOptions = this.inputCtrl.valueChanges.pipe(
      startWith(null),
      map((option: string | null) => this._filter(option))
    )
  }

  ngOnInit(): void {
  }

  /**
   * Adiciona um termo pesquisado se ele existir no array de opções disponíveis.
   * A comparação do termo com as opções não diferenia letras maiúsculas de minúsculas.
   * 
   * @param event 
   */
  async add(event: MatChipInputEvent) {

    const value = (event.value || '').trim();
    if (value) {
      const valUpper = value.toUpperCase();
      const index = this.allOptions.findIndex(option => option.toUpperCase() == valUpper);
      if (index > -1) {
        this.selectedOptions.push(this.allOptions[index]);
        // this.optionToggled.emit(this.allOptions[index]);
        this.selectedOptionsChanged.emit(this.selectedOptions);
      }
    }
    event.chipInput!.clear();
    this.inputCtrl.setValue(null);

    // await this.updateChart();
  }

  /**
   * Adiciona uma opção selecionada no auto complete ao array de opções selecionadas.
   * 
   * @param event 
   */
   selected(event: MatAutocompleteSelectedEvent) {
    this.selectedOptions.push(event.option.viewValue);
    this.optionInput.nativeElement.value = '';
    this.inputCtrl.setValue(null);
    // this.optionToggled.emit(event.option.viewValue);
    this.selectedOptionsChanged.emit(this.selectedOptions);

    // await this.updateChart();
  }

  /**
   * Remove uma opção do array de opções selecionadas.
   * 
   * @param option opção a ser removida
   */
  async remove(option: string) {
    
    const index = this.selectedOptions.indexOf(option);

    if (index > -1) {
      this.selectedOptions.splice(index, 1);
      // this.optionToggled.emit(station);
      this.selectedOptionsChanged.emit(this.selectedOptions);
    }

    // await this.updateChart();
  }

  /**
   * filtra as estações que contêm o termo de pesquisa em seus nomes.
   * 
   * @param value termo de pesquisa
   * @returns nomes das estações que incluem o termo de pesquisa
   */
   private _filter(value: string | null): string[] {
    const filterVal = value?.toUpperCase();
    
    let notSelected = this.allOptions.filter(station => ! this.selectedOptions.includes(station));
    return filterVal === null ? 
      notSelected : 
      notSelected.filter(option => option.toUpperCase().includes(filterVal));
  }

}
